// Adapted from legacy CloudHealth UI code (intentionally copied — DEVOPS-XXX)
import { Chip } from "@material-ui/core";
import type React from "react";

import type { CloudProvider } from "../../api/types";

const STATUS_COLOR_MAP: Record<string, "default" | "primary" | "secondary"> = {
  RUNNING: "primary",
  STARTED: "primary",
  ACTIVE: "primary",
  AVAILABLE: "primary",
  TERMINATED: "secondary",
  STOPPED: "default",
  STOPPING: "default",
  DEALLOCATED: "default",
  DEALLOCATING: "default",
};

export const PROVIDER_STYLE: Record<
  CloudProvider,
  { label: string; style: React.CSSProperties }
> = {
  GCP: { label: "GCP", style: { backgroundColor: "#4285F4", color: "#fff" } },
  AWS: { label: "AWS", style: { backgroundColor: "#FF9900", color: "#000" } },
  Azure: {
    label: "Azure",
    style: { backgroundColor: "#0078D4", color: "#fff" },
  },
};

export function StatusChip({ status }: { status?: string }) {
  if (!status) return null;
  const color = STATUS_COLOR_MAP[status.toUpperCase()] ?? "default";
  return <Chip size="small" label={status} color={color} />;
}
